<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>

			<el-breadcrumb-item>设备监控</el-breadcrumb-item>
		</el-breadcrumb>

		<tool-bar v-on:select="handleSelectJT" />

		<div class="monitor_section" v-if="selectedJT">
			<div class="header clearfix">
				<h3>质量监控</h3>
				<router-link :to="{ name: 'WorkshopView', query: { jt_id: selectedJT._id.$oid } }">
					<el-button style="float: right; padding: 3px 0" type="text">
						最大化
					</el-button>
				</router-link>
			</div>
			<div id="defect_view" class="view">
				<device-status id="id" :jt_id="selectedJT._id.$oid" />
			</div>
		</div>
	</div>
</template>

<script>
	import DeviceStatus from '../public/DeviceStatus'
	import ToolBar from './ToolBar'

	export default {
		components: {
			DeviceStatus,
			ToolBar,
		},
		// mixins:[maxwindous],
		data() {
			return {
				selectedJT: null,
			}
		},
		methods: {
			handleFullScreen(id) {
				const element = document.getElementById(id)
				// 判断是否已经是全屏
				// 如果是全屏，退出
				if (this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen()
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen()
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen()
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen()
					}
					console.log('已还原！')
				} else {
					// 否则，进入全屏
					if (element.requestFullscreen) {
						element.requestFullscreen()
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen()
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen()
					} else if (element.msRequestFullscreen) {
						// IE11
						element.msRequestFullscreen()
					}
					console.log('已全屏！')
				}
				// 改变当前全屏状态
				// this.fullscreen = !this.fullscreen
			},
			checkFull() {
				var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
				// to fix : false || undefined == undefined
				if (isFull === undefined) {
					isFull = false
				}
				return isFull
			},
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jt) {
				this.selectedJT = jt
				//this.$refs.defectMon.handleSelectJT()
			},
		},

		created() {},
	}
</script>

<style scoped>
	.dashboard {
		background-color: #fff;
		/* position:absolute; */
		font-size: 50px;
		padding: 10% 5%;
	}
	.fullSrccenStyle {
		padding: 100px 20px;
		background-color: #fff;
	}
	.monitor {
		padding-bottom: 20px;
		height: 400px;
	}
	.defection {
		overflow-y: auto;
		height: 360px;
	}
	/* .view{
    background-color: #fff;
	padding: 20px;
	} */
</style>
